/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DowntimeSection } from '../../models/downtime-section';

export interface GetReasonsTreeListAll$Params {
  workCenterId: number;
}

export function getReasonsTreeListAll(http: HttpClient, rootUrl: string, params: GetReasonsTreeListAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DowntimeSection>>> {
  const rb = new RequestBuilder(rootUrl, getReasonsTreeListAll.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DowntimeSection>>;
    })
  );
}

getReasonsTreeListAll.PATH = '/api/v1/Downtimes/Reasons/{workCenterId}';
